export { default } from './SuggestedQuestions';